import { Spinner, Text } from '@bn-apps/design-system-ui-react';
import { useTranslation } from 'react-i18next';
import styles from './LoadingState.module.scss';

interface LoadingStateProps {
  /** Text announced to assistive technology while the content is loading. */
  label?: string;
  /** Use a compact horizontal layout for loading a value inside existing content. */
  variant?: 'block' | 'inline';
  size?: 'xs' | 'sm' | 'md' | 'lg';
  className?: string;
}

function LoadingState({
  label,
  variant = 'block',
  size = variant === 'inline' ? 'sm' : 'md',
  className,
}: LoadingStateProps): JSX.Element {
  const { t } = useTranslation();
  const classes = [styles.loadingState, variant === 'inline' ? styles.inline : '', className ?? '']
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes} role="status" aria-live="polite">
      <Spinner size={size} aria-hidden="true" />
      <Text fontSize={variant === 'inline' ? 'sm' : 'md'}>{label ?? t('common.loading')}</Text>
    </div>
  );
}

export default LoadingState;
